import plugin from 'tailwindcss/plugin';

const skeleton = plugin.withOptions(function () {
	return function ({ addBase, addUtilities, addComponents, theme }) {
		const ui100 = theme('colors.ui.100');
		const ui75 = theme('colors.ui.75');
		const ui25 = theme('colors.ui.25');
		const radiusLg = theme('borderRadius.lg');
		const radiusMd = theme('borderRadius.md');
		const radiusXl = theme('borderRadius.xl');
		const space6 = theme('spacing.6');
		const roundedFull = theme('borderRadius.full');

		const backgroundSize = '200% 100%';
		const shimmerKeyframes = {
			'0%': { backgroundPosition: '-200% 0' },
			'100%': { backgroundPosition: '200% 0' },
		};

		const shimmerAnim = 'shimmer 1.4s linear infinite';
		const skelGradient = `linear-gradient(to right, ${ui100}, ${ui75}, ${ui100})`;

		addBase({
			'@keyframes shimmer': shimmerKeyframes,
			'@media (prefers-reduced-motion: reduce)': {
				'.animate-shimmer': { animation: 'none' },
				'.skel': { animation: 'none' },
			},
		});

		addUtilities({
			'.animate-shimmer': {
				animation: shimmerAnim,
				backgroundSize,
			},
			'.skel': {
				animation: shimmerAnim,
				backgroundImage: skelGradient,
				backgroundSize,
			},
			'.skel-line': {
				height: '0.75rem',
				borderRadius: radiusMd,
				backgroundImage: skelGradient,
				animation: shimmerAnim,
				backgroundSize,
			},
			'.skel-line-lg': {
				height: '1rem',
				borderRadius: radiusLg,
				backgroundImage: skelGradient,
				animation: shimmerAnim,
				backgroundSize,
			},
			'.skel-title': {
				height: '2.5rem',
				borderRadius: radiusXl,
				backgroundImage: skelGradient,
				animation: shimmerAnim,
				backgroundSize,
			},
			'.skel-pill': {
				height: '1.5rem',
				borderRadius: roundedFull,
				backgroundImage: skelGradient,
				animation: shimmerAnim,
				backgroundSize,
			},
			'.skel-chip': {
				height: '2rem',
				borderRadius: roundedFull,
				backgroundImage: skelGradient,
				animation: shimmerAnim,
				backgroundSize,
			},
			'.skel-dot': {
				width: '1rem',
				height: '1rem',
				borderRadius: roundedFull,
				backgroundImage: skelGradient,
				animation: shimmerAnim,
				backgroundSize,
			},
		});

		addComponents({
			'.panel': {
				borderRadius: radiusLg,
				backgroundColor: ui25,
				padding: space6,
			},
			'.hero': {
				width: '100%',
				backgroundImage: skelGradient,
				animation: shimmerAnim,
				backgroundSize,
			},
		});
	};
});

export default skeleton;
